export default __webpack_public_path__ + "static/media/right-home-trees.a04e1d93.png";